export default "__VITE_ASSET__DFGiLm58__"